<template>
    <div class="toTop" title='回到顶部' @click='goTop' v-if='!isTop'>
        <i class="iconfont icon-toTop"></i>
        <p>回到顶部</p>
    </div>
</template>

<script scoped>
    export default {
        name: "toTop",
        data() {
            return {
                isTop: 1
            };
        },
        mounted(){
            let _this = this
            document.getElementById('layoutMain').onscroll = function(){
                //触顶
                var t = document.getElementById('layoutMain').scrollTop;
                if( t > 0 ) {
                    _this.isTop = 0;
                } else { 
                    _this.isTop = 1;
                }
            }
        },
        methods: {
            goTop() {
                document.getElementById('layoutMain').scrollTop = 0
            }
        }
    };
</script>

<style type="text/less" lang="less" scoped>
    .toTop{
        position: fixed;
        bottom: 60px;
        right: 20px;
        text-align: center;
        cursor: pointer;
        color: #5a91e8;
        font-size: 12px;
        z-index: 99;
        i{ font-size: 30px; }
        p{ margin: 3px 0 0; }
        &:hover{ color: #2b77ef; }
    }
</style>


// WEBPACK FOOTER //
// src/components/toTop.vue